import React from "react";
import classNames from "classnames";

import { getTutorialVideoUrl } from "features/Resources/tutorialVideos";
import sharedClasses from "features/Model/sharedStyles.module.scss";

import linkOut from "assets/images/icons/linkOut.svg";

import classes from "./style.module.scss";

export default ({ videoKey, label = "Video Tutorial", className }) => (
    <a
        href={getTutorialVideoUrl(videoKey)}
        target="_blank"
        rel="noopener noreferrer"
        className={classNames(classes.videoTutorialLink, sharedClasses.externalLink, className)}
    >
        {label}
        <img src={linkOut} alt="" />
    </a>
);
